import { CHANNELS } from "@/mocks/gua";

const LINKS = [
  { label: "今日新瓜速递", href: "#today" },
  { label: "热门前排围观", href: "#hot" },
  { label: "瓜田合集", href: "#collection" },
  { label: "分区速览", href: "#zone" },
  { label: "现场直击", href: "#scene" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-[#f1e9dc]">
      <div className="mx-auto w-full px-4 py-10 md:px-6">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-orange-600 text-white">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="text-lg font-extrabold tracking-tight text-stone-900">九一吃瓜</span>
            </a>
            <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-500">
              新瓜速递 · 热门事件前排围观现场。一手现场图文直击，帮你第一时间吃到最新最热的那口瓜。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-stone-800">页面索引</h4>
            <ul className="mt-3 grid grid-cols-2 gap-2">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-xs text-stone-500 transition hover:text-orange-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-stone-800">热门频道</h4>
            <div className="mt-3 flex flex-wrap gap-2">
              {CHANNELS.slice(0, 6).map((c) => (
                <a
                  key={c}
                  href="#zone"
                  className="whitespace-nowrap rounded-full border border-stone-300/70 bg-[#faf6ef] px-3 py-1 text-[11px] text-stone-600 transition hover:border-orange-300 hover:text-orange-700"
                >
                  {c}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-stone-300/70 pt-5 sm:flex-row">
          <p className="text-[11px] text-stone-400">
            © {new Date().getFullYear()} 九一吃瓜 · 内容仅作展示用途
          </p>
          <p className="flex items-center gap-1.5 text-[11px] text-stone-400">
            <i className="ri-refresh-line text-orange-500" /> 今日新瓜速递已更新
            <span className="font-bold text-orange-600">96</span> 条
          </p>
        </div>
      </div>
    </footer>
  );
}